import { computed, Ref } from '@vue/composition-api'
import { UserInfoState } from '@/layout/types'
import { fetchPlanVersion } from '@/api/user'
import { RUNTIME_ENV } from '@/constants/environment'
import omit from 'lodash/omit'

import { useRequest, RequestFunc } from '@shared/use/use-request'
import qs from 'qs'

export const SUPPORT_URL = 'https://support.okki.com'

// 体验系统跳转智齿客服需移除下面这些key
const EXP_EXCLUDE_QUERYS = ['partnerid']
// 测试环境下：
// 1）传入clientid字段时：clientid-test
// 2）传入userid字段时：userid-test
// 3）传入partnerid字段时：userid-test
const isProduction = ['production', 'omg'].includes(RUNTIME_ENV)

export interface PlanVersion {
  system: string
  modules: string[]
}

export const usePlanVersion = () => {
  const { data, loading } = useRequest<PlanVersion>(fetchPlanVersion as RequestFunc, {
    initialData: {},
    cacheKey: 'PLAN_VERSION',
    staleTime: -1,
  })

  return {
    planVersion: data,
    loadingPlan: loading,
  }
}

export const useZhichiService = (userInfoState: UserInfoState, planVersion: Ref<PlanVersion>) => {
  const zhichiConfig = computed(() => {
    const {
      env,
      is_trial = 0,
      nickname = '',
      user_id = '',
      client_id = '',
      userId = '',
      email = '',
      family_name = '',
      second_name = '',
      user_language = 'zh-CN',
    } = userInfoState
    const languageMap = {
      'zh-CN': 'cn',
      'zh-TW': 'tw',
      en: 'en',
    }
    const planVersionContent = Number(is_trial)
      ? 'OKKI Lucky'
      : encodeURIComponent([planVersion.value.system].concat(planVersion.value.modules).join('&'))
    const visitUrl = encodeURIComponent(location.href)
    const zhichiUserId = isProduction ? userId || user_id : `${user_id}-test`
    const zhichiClientId = isProduction ? client_id : `${client_id}-test`

    const config = {
      email,
      visitUrl,
      uname: email,
      partnerid: zhichiUserId,
      locale: languageMap[user_language],
      realname: `${family_name} ${second_name}`,
      customer_fields: JSON.stringify({
        /**
         * 用户ID
         */
        customField2: zhichiUserId,
        /**
         * 公司ID
         */
        customField3: zhichiClientId,
        /**
         * 版本信息
         */
        customField4: planVersionContent,
      }),
    }

    return env === 'exp' ? omit(config, EXP_EXCLUDE_QUERYS) : config
  })

  const openZhichiService = () => {
    window.open(`${SUPPORT_URL}?${qs.stringify(zhichiConfig.value)}`)
  }

  return {
    openZhichiService,
  }
}
